export const DRAW_ON_MAP = 'DRAW_ON_MAP';
export const SELECT_GEOMETRY = 'SELECT_GEOMETRY';
export const SELECT_POPUP_EDIT_GEOMETRY = 'SELECT_POPUP_EDIT_GEOMETRY';

export function drawOnMap(draw) {
  return {
    type : DRAW_ON_MAP,
    payload : draw
  }
}

export function selectGeometry(featureID) {
  return {
    type : SELECT_GEOMETRY,
    payload : featureID
  }
}

export function selectPopupEditGeometry(featureID) {
  return {
    type : SELECT_POPUP_EDIT_GEOMETRY,
    payload : featureID
  }
}



// WEBPACK FOOTER //
// ./src/actions/actions_map.js